const Email = () => {
  return (
    <svg width="24" height="19" viewBox="0 0 24 19" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M1.2 0H22.8C23.1183 0 23.4235 0.106762 23.6485 0.296798C23.8736 0.486835 24 0.744581 24 1.01333V17.2267C24 17.4954 23.8736 17.7532 23.6485 17.9432C23.4235 18.1332 23.1183 18.24 22.8 18.24H1.2C0.88174 18.24 0.576515 18.1332 0.351472 17.9432C0.126428 17.7532 0 17.4954 0 17.2267V1.01333C0 0.744581 0.126428 0.486835 0.351472 0.296798C0.576515 0.106762 0.88174 0 1.2 0ZM12.072 8.79877L4.3776 3.28117L2.8236 4.82549L12.0876 11.4679L21.1848 4.82043L19.6152 3.28725L12.0732 8.79877H12.072Z" fill="white"/>
    </svg>
  )
}

export default Email;
